/// <reference path="../jquery/jquery.d.ts" />
/// <reference path="./loginpanel.ts" />
/// <reference path="./d/app.d.ts" />

class AuthHandler
{
	constructor()
	{
		$(window).on('click', 'a', (e) =>
		{
			let $this = $(e.currentTarget);
			let url = $this.attr('href');

			if ($this.data('login')) {
				this.show("join", url);
				return false;
			}

			let res = url.match(/^\/(login|join)(.*)$/);

			if (res !== null) {
				e.preventDefault();
				this.show(res[1], res[2]);
				return false;
			}
		});
	}

	showJoin (url)
	{
		this.show("join", url);
	}
	showLogin (url)
	{
		this.show("login", url);
	}

	show(panel, url)
	{
		debug.log("authHandler::show", panel, url);
		if ("landingPromo" in window && panel=="join") {
			debug.log("authHandler::show", "landingPromo");
			landingPromo.show(true);
		}
		else
		if ("loginPanel" in window) {
			debug.log("authHandler::show", "loginPanel");
			scrollPanelHandler.showPanel("login_" + (panel == "login" ? "right" : "left"));
		}
		else {
			debug.error("No login panel handler found");
		}
	}
}
